import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import axios from 'axios';

const useBlogMedia = (blogTypeData) => {

    const navigate = useNavigate()
    const [files, setFiles] = useState([]);


    const getAllpictures = (temp) => {
        temp.forEach((element) => {
            if (element?.file_id) {
                axios
                    .get('/media/api/file/upload', {
                        responseType: 'blob',
                        params: { file_id: element?.file_id },
                    })
                    .then((response) => {
                        const blob_ = new Blob([response.data], { type: 'image/jpg' });
                        const dataurl = URL.createObjectURL(blob_);
                        setFiles((prev) => [
                            ...prev,
                            { file_id: element?.file_id, file_url: dataurl },
                        ]);
                    });
            }
        });
    };

    const get_picture = (file_id) => {
        const file = files.find((element) => element.file_id === file_id);
        return file?.file_url;
    };
    // 判斷內外部連結及導向方式
    const toLinkSomewhere = (extermal_link_check, external_link) => {
        if (external_link.length > 0) {
            if (extermal_link_check === 0) {//內部連結
                navigate(external_link)
            }
            else {//外部連結
                window.open(external_link, '_blank');
            }
        }
    }
    //判斷詳細內容所見即所示元件是否有填寫內容，回傳值決定按鈕是否要顯示
    const isMoreContentEmpty = (more_content) => {
        if (!more_content) return true; // 若內容為 null 或 undefined，視為空
        const cleanedContent = more_content.trim().replace(/<p>\s*(<br\s*\/?>)?\s*<\/p>/g, '');
        return cleanedContent.length === 0; // 若清理後長度為 0，視為空
    }

    // 用於顯示媒體內容
    const renderMediaContent = (youtubeIframe, blogFiles, sliderSettings, contentStyle) => {
        if (youtubeIframe && youtubeIframe.length !== 0) {
            return (
                <div
                    style={{
                        ...contentStyle
                    }}
                    dangerouslySetInnerHTML={{ __html: youtubeIframe }}
                />
            );
        } else {
            return (
                <Slider {...sliderSettings}>
                    {(blogFiles || []).map((file, fileIndex) => (
                        <div key={fileIndex} style={{ width: '100%' }}>
                            <div
                                style={{
                                    ...contentStyle,
                                    backgroundImage: file.file_id
                                        ? `url(${get_picture(file.file_id)})`
                                        : `url(/defaultImage.png)`,
                                }}
                            />
                        </div>
                    ))}
                </Slider>
            );
        }
    };

    useEffect(() => {
        blogTypeData.forEach((blogTypeDataValue) => {
            blogTypeDataValue?.frontend_column_frontend_component_blog_type_blog_data.forEach(
                (frontend_column_frontend_component_blog_type_blog_data_value) => {
                    getAllpictures(
                        frontend_column_frontend_component_blog_type_blog_data_value
                            ?.blog_type_classify_structure_type_blog_data ?? []
                    );
                }
            );
        });
    }, [blogTypeData]);

    return { files, get_picture, toLinkSomewhere, isMoreContentEmpty, renderMediaContent };
};

export default useBlogMedia;
